import { gql } from '@apollo/client'
import { Heading } from '@farol-ds/react'

import { useChooseOfferFrequencyLaterContext } from '../../context-provider'
import { useChooseFrequencyLaterSendLockEvent } from '../../use-choose-frequency-later-send-lock-event'
import { ChooseFrequencyLaterStep } from '../steps'
import {
  ChooseFrequencyLaterStepsContent_OfferLockDataFragment,
  ChooseFrequencyLaterStepsContent_ViewerFragment,
} from './__generated__/choose-frequency-later-steps-content.graphql'
import styles from './choose-frequency-later-steps-content.module.scss'

interface ChooseFrequencyLaterStepsContentProps {
  offerLockData: ChooseFrequencyLaterStepsContent_OfferLockDataFragment
  viewer: ChooseFrequencyLaterStepsContent_ViewerFragment
}

export const ChooseFrequencyLaterStepsContent = ({
  viewer,
  offerLockData,
}: ChooseFrequencyLaterStepsContentProps) => {
  useChooseFrequencyLaterSendLockEvent({ offerLockData })
  const { isPaywall, currentStep } = useChooseOfferFrequencyLaterContext()

  return (
    <ChooseFrequencyLaterStep>
      {currentStep === 'selectOffer' ? (
        <>
          {isPaywall && (
            <Heading size="lg" className={styles.paywallHeader}>
              Escolha o plano ideal para você
            </Heading>
          )}

          <ChooseFrequencyLaterStep.SelectOffer offerLockData={offerLockData} />
        </>
      ) : (
        <>
          {isPaywall && (
            <Heading size="lg" className={styles.paywallHeader}>
              Defina seu ciclo de cobrança
            </Heading>
          )}

          <ChooseFrequencyLaterStep.SelectFrequency offerLockData={offerLockData} viewer={viewer} />
        </>
      )}
    </ChooseFrequencyLaterStep>
  )
}

ChooseFrequencyLaterStepsContent.fragments = {
  offerLockData: gql`
    fragment ChooseFrequencyLaterStepsContent_offerLockData on OfferLockData {
      header {
        toggle {
          options
          defaultOption
        }
      }
      ...ChooseFrequencyLaterStep_offerLockData
    }
    ${ChooseFrequencyLaterStep.fragments.offerLockData}
  `,
  viewer: gql`
    fragment ChooseFrequencyLaterStepsContent_viewer on Profile {
      ...ChooseFrequencyLaterStep_viewer
    }
    ${ChooseFrequencyLaterStep.fragments.viewer}
  `,
}
